export class ProvinceDTO {
  public provinceCode: string;
  public description: string;
  public status: string;
  public user: string;
  public url: string;

  constructor(provinceCode: string, description: string, status: string, user: string, url: string) {
    this.provinceCode = provinceCode;
    this.description = description;
    this.status = status;
    this.user = user;
    this.url = url;
  }
}
